import { CurrencyPipe } from '@angular/common';
import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[numberWithLeadingZero]',
  standalone: false,
})
export class NumberWithLeadingZeroDirective implements AfterViewInit {
  constructor(
    private elementRef: ElementRef,
    private model: NgControl,
    private currencyPipe: CurrencyPipe
  ) {}

  ngAfterViewInit() {
    // NOTE: Added below to display 2 decimal always in the view.
    // Because when we get amount like 18510.5 it should display as $18,510.50
    // Without below code it displays as $18,510.5, dropping the last zero.
    const amount = this.model.value;
    if (amount) {
      this.elementRef.nativeElement.value = this.currencyPipe.transform(amount) || '';
    }
  }
}
